import { render, staticRenderFns } from "./UiBaseIcon.vue?vue&type=template&id=e7bedb4a&scoped=true&"
import script from "./UiBaseIcon.vue?vue&type=script&lang=js&"
export * from "./UiBaseIcon.vue?vue&type=script&lang=js&"
import style0 from "./UiBaseIcon.vue?vue&type=style&index=0&id=e7bedb4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bedb4a",
  null
  
)

export default component.exports